module.exports = __webpack_public_path__ + "static/img/datashare1.e46df8b3.png";